import React from 'react';
import { components } from 'react-select';
import { CollapsedTagCount } from './MultiSelect.styled';

const TAG_WIDTH_ESTIMATE = 95; // px
const AVAILABLE_WIDTH = 260; // px

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CompactMultiValue = ({ index, getValue, ...props }: any) => {
  const selectedValues = getValue();
  // Estimate how many tags can fit in the available width
  const maxVisibleTagCount = Math.floor(AVAILABLE_WIDTH / TAG_WIDTH_ESTIMATE);
  const hiddenTagCount = selectedValues.length - maxVisibleTagCount;

  // Only render if this tag should be visible
  if (index < maxVisibleTagCount) {
    const isLastVisible = index === maxVisibleTagCount - 1;

    // Render "+N" collapsed tag indicator if there are hidden items
    if (isLastVisible && hiddenTagCount > 0) {
      return (
        <>
          <components.MultiValue {...props} />
          <CollapsedTagCount>+{hiddenTagCount}</CollapsedTagCount>
        </>
      );
    }

    return <components.MultiValue {...props} />;
  }

  return null;
};
